(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DecisioneDeleteController',DecisioneDeleteController);

    DecisioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Decisione'];

    function DecisioneDeleteController($uibModalInstance, entity, Decisione) {
        var vm = this;

        vm.decisione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Decisione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
